import clsx from "clsx";

export interface RoomGalleryProps {
  Gallery: JSX.Element;
}

export function RoomGallery({ Gallery }: RoomGalleryProps) {
  return <div className={clsx("RoomGallery")}>{Gallery}</div>;
}
